// src/pages/Layout.jsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import useContextoOrcamento from '../hooks/useContextoOrcamento';

// A Home nunca é bloqueada: é ela que tem o botão "Contexto", o único lugar
// onde o usuário escolhe coligada/filial/ano. Barrar a Home junto deixaria quem
// está sem contexto num beco sem saída — sem tela e sem como consertar.
const ROTAS_SEM_CONTEXTO = ['/home'];

export default function Layout() {
  // 🧭 Coligada/filial/ano são resolvidos AQUI, antes de qualquer tela de
  // lançamento montar. Elas leem PCODCOLIGADA/PCODFILIAL direto do localStorage
  // no corpo do componente; montando sem essas chaves, a consulta sairia com
  // CODCOLIGADA = 'null' e voltaria vazia — sem erro, com cara de "não tem
  // dado". Segurar o <Outlet/> é o que impede isso.
  const { estado, nome, tentarNovamente } = useContextoOrcamento();
  const { pathname } = useLocation();

  const rotaLivre = ROTAS_SEM_CONTEXTO.some(
    (r) => pathname === r || pathname.startsWith(r + '/')
  );
  const liberado = estado === 'pronto' || rotaLivre;

  return (
    <div className="d-flex" >
      <Sidebar nomePessoa={nome} />
      <div className="flex-grow-1 p-3" style={{ background: 'linear-gradient(to bottom right, #e5e7eb, #F0FFFF)' }}>
        {liberado && <Outlet />}

        {!liberado && estado === 'carregando' && (
          <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="text-muted mb-0">Carregando contexto (coligada, filial e ano)...</p>
          </div>
        )}

        {!liberado && estado === 'erro' && (
          <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
            <div className="mb-3" style={{ fontSize: '2.5rem' }}>🧭</div>
            <h5 className="fw-bold mb-2">Escolha a filial e o ano</h5>
            <p className="text-muted mb-1" style={{ maxWidth: '480px' }}>
              Esta tela precisa de uma coligada e filial definidas. Sem isso a
              busca sairia sem filtro e voltaria vazia, como se não houvesse dado.
            </p>
            <p className="text-muted small mb-3" style={{ maxWidth: '480px' }}>
              Abra a <strong>Home</strong> e use o botão <strong>Contexto</strong> para
              escolher. Se lá também não aparecer nenhuma filial, seu usuário pode
              estar sem coligada/filial no TOTVS — nesse caso, fale com o suporte.
            </p>
            <div className="d-flex gap-2">
              <a href="/orcamento/home" className="btn btn-primary">Ir para a Home</a>
              <button type="button" className="btn btn-outline-secondary" onClick={tentarNovamente}>
                Tentar novamente
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
